const modelsList = [
  "Baleno 1.5 GL MT",
  "Baleno 1.5 GL AT",
  "Baleno 1.5 GLX MT",
  "Baleno 1.5 GLX AT",
  "Celerio 1.0 GA MT",
  "Celerio 1.0 GL MT",
  "Celerio 1.0 GL AMT",
  "Ciaz 1.5 GL 5MT",
  "Ciaz 1.5 GL 4AT",
  "Ciaz 1.5 GLX 5MT",
  "Ciaz 1.5 GLX 4AT",
  "Dzire 1.2 GA 5MT",
  "Dzire 1.2 GL 5MT",
  "Dzire 1.2 GL AMT",
  "Ertiga 1.5 GA MT",
  "Ertiga 1.5 GL MT",
  "Ertiga 1.5 GL AT",
  "Ertiga 1.5 GLX MT",
  "Ertiga 1.5 GLX AT",
  "Ignis 1.2 GL MT",
  "Ignis 1.2 GLX MT",
  "Ignis 1.2 GLX AMT",
  "Jimny 1.5 GA 5MT",
  "Jimny 1.5 GL 5MT",
  "Jimny 1.5 GL 4AT",
  "Jimny 1.5 GLX 5MT",
  "Jimny 1.5 GLX 4AT",
  "S-Presso 1.0 GL 5MT",
  "S-Presso 1.0 GL+ 5MT",
  "S-Presso 1.0 GL+ AMT",
  "S-Presso 1.0 S-EDITION 5MT",
  "S-Presso 1.0 S-EDITION AMT",
  "Super Carry 1.2",
  "Swift 1.2 GA MT",
  "Swift 1.2 GL MT",
  "Swift 1.2 GL AMT",
  "Swift 1.2 GLX MT",
  "Swift 1.2 GLX AMT",
  "Swift Sport 1.4 Turbo MT",
  "Swift Sport 1.4 Turbo AT",
  // "Vitara 1.6 GL 5MT 2WD",
  // "Vitara 1.6 GL+ 5MT 2WD",
  // "Vitara 1.6 GL+ 6AT 2WD",
  // "Vitara 1.6 GLX 6AT 2WD",
  "Vitara 1.6 GLX 5MT ALLGRIP",
  "Vitara 1.4 TURBO GLX 6MT",
  "Vitara 1.4 TURBO GLX 6AT",
  "Vitara Brezza 1.5 GL 5MT",
  "Vitara Brezza 1.5 GL 4AT",
  "Vitara Brezza 1.5 GL S-Edition 5MT",
  "Vitara Brezza 1.5 GL S-Edition 4AT",
  "Vitara Brezza 1.5 GLX 5MT",
  "Vitara Brezza 1.5 GLX 4AT",
];

export default modelsList;
